export default __webpack_public_path__ + "static/media/Thug's Mask of Charred Earth.34961f99.jpg";